import React, { useEffect, useReducer } from "react";
import axios from "axios";
import moment from "moment";
import InterestContext from "./interestContext";
import InterestReducer from "./interestReducer";
import setAuthToken from "../../functions/auth_header";
import findBrand from "../../components/findBrand";
import { getsites, getMainDomainNew } from "../../components/findBrand";
import { brandDomains, fetchBrands } from "../../components/brand";
import ErrorLogger from "../../components/ErrorLogger";


import {
  GET_AGE,
  GET_SITE_INFORMATION,
  GET_BRAND_SITE,
  GET_SITE_PROGRAM,
  GET_PROGRAMTYPESFORWEB,
  GET_SCHOOLTYPESFORWEB,
  LEVEL_DOWN,
  LEVEL_UP,
  ON_FORM_DATA_CHANGE,
  APPLY_FILTER,
  ON_ZIP_SEARCH_CHANGE,
  SET_PASS,
  SET_LOADING,
  GET_ZIP_SITES,
  SUBMIT_DATA,
  GET_BRAND_DATA,
  RESET_INTEREST_FORM
} from "../types";
import { getAppUrl, getLocationApiUrl } from "../../functions/getEnv";

const InterestState = (props) => {
  const initialState = {
    formData: {
      campaign: "",
      studentFirstName: "",
      studentLastName: "",
      birthDate: "",
      parentRelationship: "",
      parentFirstName: "",
      parentLastName: "",
      primaryEmail: "",
      phone: "",
      street1: "",
      street2: "",
      state: "",
      charter: "",
      region: "",
      city: "",
      country: "",
      zipCode: "",
      sameAddress: false,
      mailingStreet1: "",
      mailingStreet2: "",
      mailingCity: "",
      mailingState: "",
      mailingRegion: "",
      mailingCountry: "",
      mailingZipCode: "",
      learningCenterName: "",
      learningCenterCharter: "",
      learningCenterAddress: "",
      charterWebsite: "",
      charterContactnumber: "",
      brandIcon: "",
      principal: "",
      learningCenterId: "",
      status: "New Interest",
      lastContactDate: "",

    },
    siteInformation: {},
    brandSites: [],
    brandName: [],
    Siteprogram: {},
    learningCenterCoordinates: {},
    zipSearch: {
      brandName: "",
      programType: "",
      schoolType: "",
      zipcode: "",
      state: "",
    },
    zipSites: [],
    stateSites: [],
    zipCoordinates: {},
    stateCoordinates: {},
    loading: false,
    formLevel: 0,
    age: 0,
    pass: {
      initial: true,
      parents: true,
      contact: true,
      address: true,
      mailing: true,
    },
    preSelected: false,
    charterBrandName: "Learn4Life",
    programTypesforweb: [],
    schoolTypesforweb: [],
  };

  const [state, dispatch] = useReducer(InterestReducer, initialState);
  const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);
  const locationApiUrl = getLocationApiUrl(import.meta.env.VITE_NODE_ENV);

  const getSiteInformation = async (id) => {
    try {
      const res = await axios.get(`${locationApiUrl}/enrollment-site/${id}`);
      dispatch({ type: GET_SITE_INFORMATION, payload: res.data });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  useEffect(() => {
    const loadBrands = async () => {
      await fetchBrands();
    };

    loadBrands();
  }, []);

  const brand_holston = brandDomains.brand_holston?.name;
  const brand_learn4life = brandDomains.brand_learn4life?.name;
  const brand_elev8 = brandDomains.brand_elev8?.name;
  const brand_llac = brandDomains.brand_llac?.name;
  const brand_flexhigh = brandDomains.brand_flexhigh?.name;
  const brand_pbia = brandDomains.brand_pbia?.name;
  const brand_stanza = brandDomains.brand_stanza?.name;

  const getSiteprogram = async (id) => {
    try {
      const authRes = await axios.get(`${appUrl}/auth/webapp`);
      const userAccessToken = authRes.data.accessTokens[0];
      setAuthToken(userAccessToken);

      const res = await axios.get(
        `${locationApiUrl}/enrollment-site-program/${id}`
      );

      dispatch({ type: GET_SITE_PROGRAM, payload: res.data });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const levelUp = () => {
    dispatch({ type: LEVEL_UP });
  };

  const levelDown = () => {
    dispatch({ type: LEVEL_DOWN });
  };

  const getAge = (dateString) => {
    var today = new Date();
    var birthDate = new Date(dateString);
    var newAge = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      newAge--;
    }
    dispatch({ type: GET_AGE, payload: newAge });
  };

  const setPass = (name, value) => {
    dispatch({ type: SET_PASS, payload: { name, value } });
  };

  const setLearningCenter = (data) => {
    dispatch({ type: "SET_LEARNING_CENTER", payload: data });
  };

  const onFormDataChange = (e) => {
    dispatch({
      type: ON_FORM_DATA_CHANGE,
      payload: {
        name: e.target.name,
        value:
          e.target.name === "sameAddress" ? e.target.checked : e.target.value,
      },
    });
  };
  const applyFilter = () => {
    dispatch({
      type: APPLY_FILTER,
      payload: {},
    });
  };
  const onZipSearchChange = (e) => {
    dispatch({
      type: ON_ZIP_SEARCH_CHANGE,
      payload: {
        name: e.target.name,
        value: e.target.value,
      },
    });
  };

  const setLoading = (bool) => {
    dispatch({ type: SET_LOADING, payload: bool });
  };

  const getProgramtypesforweb = async () => {
     const authRes = await axios.get(`${appUrl}/auth/webapp`);
    const userAccessToken = authRes.data.accessTokens[0];
    setAuthToken(userAccessToken);
    try {     
      const res = await axios.get(`${locationApiUrl}/programtypesforweb/`);
      const programTypesforweb = res.data.data || res.data; 
      dispatch({ type: GET_PROGRAMTYPESFORWEB, payload: programTypesforweb });
      

    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const getSchoolTypesforweb = async () => {
    try {
      const BaseUrl = document.location.hostname;
      const findTerm = (term) => {
        if (BaseUrl.includes(term)) {
          return BaseUrl;
        }
      };
      let brandName;
      switch (BaseUrl) {
        case findTerm(brand_llac?.toLowerCase()):
          brandName = "";
          break;
        case findTerm(brand_learn4life?.toLowerCase()):
          brandName = "Learn4Life";
          break;
        case findTerm(brand_flexhigh?.toLowerCase()):
          brandName = "Flex High";
          break;
        case findTerm(brand_stanza?.toLowerCase()):
          brandName = "StanzaAcademy";
          break;
        case findTerm(brand_holston?.toLowerCase()):
          brandName = "Holston";
          break;
        case findTerm(brand_pbia?.toLowerCase()):
          brandName = "Palm Beach International";
          break;
        case findTerm(brand_elev8?.toLowerCase()):
          brandName = "Elev8";
          break;
        default:
          brandName = "";
          break;
      }
      const res = await axios.get(
        `${locationApiUrl}/schoolTypesforweb/?brandName=${brandName}`
      );

      dispatch({ type: GET_SCHOOLTYPESFORWEB, payload: res.data });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const getZipLocations = async (
    brandName,
    schoolTypes,
    programTypes,
    zip,
    state,
    charter,
  ) => {
    const brand = getsites();
    try {
      
      switch (brand.toLowerCase()) {

        case brand_llac?.toLowerCase():
          brandName = "llac";
          break;
        case brand_learn4life?.toLowerCase():
          brandName = "Learn4Life";
          break;
        case brand_flexhigh?.toLowerCase():
          brandName = "Flex High";
          break;
        case brand_stanza?.toLowerCase():
          brandName = "StanzaAcademy";
          break;
        case brand_elev8?.toLowerCase():
          brandName = "Elev8";
          break;
        case brand_holston?.toLowerCase():
          brandName = "Holston";
          break;
        case brand_pbia?.toLowerCase():
          brandName = "Palm Beach International";
          break;
        default:
          brandName = "";
          break;
      }

      dispatch({ type: SET_LOADING, payload: true });
      const res = await axios.get(
        `${locationApiUrl}/sites-distance-bybrand/${brandName}/${schoolTypes}/${programTypes}/${zip}/${state}/${charter}`
      );
      dispatch({ type: GET_ZIP_SITES, payload: res.data });
 
// The sites are in res.data.data, not res.data
if (res.data && res.data.data && Array.isArray(res.data.data)) {
  const sortedSites = res.data.data.sort((a, b) => {
    const zipA = String(a.address?.zip || '').trim();
    const zipB = String(b.address?.zip || '').trim();
    const searchZip = String(zip || '').trim();
    
    if (zipA === searchZip && zipB !== searchZip) return -1;
    if (zipB === searchZip && zipA !== searchZip) return 1;
    
    return (a.distance || 0) - (b.distance || 0);
  });
  
  dispatch({ type: GET_ZIP_SITES, payload: { data: sortedSites, zipCoordinates: res.data.zipCoordinates } });
} else {
  dispatch({ type: GET_ZIP_SITES, payload: res.data });
}
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
      //throw new Error(error.response?.data?.message || "An error occurred while fetching locations.");
    }
  };


  const getBrandbySite = async () => {
    const BaseUrl = window.location.href;
    //const BaseUrl = "enrollments.holstonacademy.org";
    const brandName = findBrand(BaseUrl);
    try {
      const res = await axios.get(
        `${locationApiUrl}/sites-bybrand/${brandName}`
      );
      dispatch({ type: GET_BRAND_SITE, payload: res.data });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const getBrandName = async () => {
    const BaseUrl = window.location.href;
    //const BaseUrl = "enrollments.holstonacademy.org";
    const brandName = findBrand(BaseUrl);

    try {
      const res = await axios.get(
        `${locationApiUrl}/sites-bybrand/${brandName}`
      );
      dispatch({ type: GET_BRAND_DATA, payload: res.data });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const submitData = async (data) => {
    try {
      const res = await axios.post(`${appUrl}/api/enrollment/`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      dispatch({ type: SUBMIT_DATA });
      return res.data._uuid; // Return the saved record _uuid
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
      return null;
    }
  };

  const submitDataPublic = async (data) => {
    try {
      const res = await axios.post(`${appUrl}/api/enrollment/public`, data, {
        headers: {
          "Content-Type": "application/json",
          Secret: import.meta.env.VITE_API_SECRET,
        },
      });
      dispatch({ type: SUBMIT_DATA });
      return res.data._uuid; // Return the saved record _uuid
    } catch (error) {
      console.error("Error submitting interest data:", error.message);
      ErrorLogger.logError(error.message);
      return null;
    }
  };

  const preSelectedSite = (siteString) => {
    try {
      dispatch({ type: "PRE_SELECTED_SITE", payload: siteString });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const charterPreSelected = (charterString) => {
    try {
      dispatch({ type: "PRE_SELECTED_CHARTER", payload: charterString });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const setCampaignType = (value) => {
    try {
      dispatch({ type: "SET_CAMPAIGN_TYPE", payload: value });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const resetInterestForm = () => {
    dispatch({ type: RESET_INTEREST_FORM });
  };
  const sendInterestEmail = async (data, interestRecordId) => {
    try {
      const currURL = window.location.href;

      const url = new URL(currURL);
      const siteParam = url.searchParams.get('site');

      // Set id based on whether site parameter exists
      const id = siteParam ? siteParam : '0';
      data.learningCenterId = id;


      let emailData = {};

      // Check if learningCenterId is not '0'
      if (data.learningCenterId !== '0') {
        const siteDetailsResponse = await axios.get(
          `${locationApiUrl}/enrollment-site-program/${id}`
        );

        const site = siteDetailsResponse.data;

        const principalPerson = site.people.find(
          (person) =>
            person.category === "LEADERSHIP" &&
            person.role_match &&
            person.role_match.name === "Principal"
        );

        emailData = {
          name: `${data.studentFirstName} ${data.studentLastName}`,
          pgName: `${data.parentFirstName} ${data.parentLastName}`,
          primaryEmail: data.primaryEmail,
          learningCenterName: site.name,
          learningCenterCharter: site.charter.name,
          learningCenterAddress: `${site.address.address_1}, ${site.address.city}, ${site.address.state}, ${site.address.zip}`,
          charterWebsite: site.charter.charterWebsite,
          charterContactnumber: site.charter.charterContactnumber,
          brandIcon: site.charter.brand.brandIcon,
          brandPhoto: site.charter.brand.brandPhoto,
          principal: principalPerson ? principalPerson.person.name : "Unassigned",
          learningCenterId: data.learningCenterId,
          brandName: site.charter.brand.brandName,
          EnrollmentsUrl: site.charter.brand.EnrollmentsUrl,
          domain: site.charter.brand.domain,
          interestEmail: site.enrollment_info.interestEmail,
        };

      }
      else {
        //Declared above variable using here 
        const llac = brand_llac;
        const learn4life = brand_learn4life;
        const elev8schools = brand_elev8;
        const holstonacademy = brand_holston;
        const pbiacademy = brand_pbia;
        const flexhigh = brand_flexhigh;
        const stanza = brand_stanza;

        // Use default values for emailData
        const domain = getMainDomainNew();
        // Get brand photo based on brand name
        const getBrandPhoto = () => {
          const brand = domain;
          // Get brand photo based on brand name
          switch (brand) {
            case "llac":
              return brandDomains.brand_learn4life.brandPhoto;
            case "learn4life":
              return brandDomains.brand_learn4life.brandPhoto;
            case "elev8schools":
              return brandDomains.brand_elev8.brandPhoto;
            case "holstonacademy":
              return brandDomains.brand_holston.brandPhoto;;
            case "pbiacademy":
              return brandDomains.brand_holston.brandPhoto;;
            case "flexhigh":
              return brandDomains.brand_flexhigh.brandPhoto;;
            case "stanza":
              return brandDomains.brand_stanza.brandPhoto;;
            default:
              // Try to get from Siteprogram as fallback
              return brandDomains.brand_learn4life.brandPhoto;
          }
        };

        const brandIcon = getBrandPhoto();

        emailData = {
          name: `${data.studentFirstName} ${data.studentLastName}`,
          pgName: `${data.parentFirstName} ${data.parentLastName}`,
          primaryEmail: data.primaryEmail,
          learningCenterName: "", // Default value
          learningCenterCharter: "", // Default value
          learningCenterAddress: "", // Default value
          charterWebsite: "#", // Default value
          charterContactnumber: "Contact us for details", // Default value
          brandIcon: brandIcon, // Default value
          brandPhoto: "", // Default value
          principal: "Enrollment Team", // Default value
          learningCenterId: data.learningCenterId,
          brandName: "Our School", // Default value
          EnrollmentsUrl: "#", // Default value
          domain: domain, // Default value
          interestEmail: data.primaryEmail, // Default value
        };
      }

      // Log the final email data

      // Check for any undefined or null values
      const undefinedKeys = Object.keys(emailData).filter(
        (key) => emailData[key] === undefined || emailData[key] === null
      );
      if (undefinedKeys.length > 0) {
        console.warn("Warning: Found undefined/null values in:", undefinedKeys);
      }


      // Add the interest record ID to email data
      if (interestRecordId) {
        emailData.interestRecordId = interestRecordId;
      } else {
        console.warn("Warning: No interest record ID provided!"); // Debug log
      }


      // Send the email
      const res = await axios.post(
        `${appUrl}/api/email/interest-email`,
        emailData
      );
      //console.log("Email sent successfully:", res.data);

      //this is commented because two mails are sending for interest forms.
      // const res1 = await axios.post(
      //    `${appUrl}/api/email/interest-notification-email`,
      //    emailData
      //  );

    } catch (error) {
      console.error("Error message:", error.message);
      ErrorLogger.logError(error.message);
    }
  };
  return (
    <InterestContext.Provider
      value={{
        formData: state.formData,
        siteInformation: state.siteInformation,
        Siteprogram: state.Siteprogram,
        programTypesforweb: state.programTypesforweb,
        schoolTypesforweb: state.schoolTypesforweb,
        learningCenterCoordinates: state.learningCenterCoordinates,
        zipSearch: state.zipSearch,
        filter: state.filter,
        zipSites: state.zipSites,
        stateSites: state.stateSites,
        brandSites: state.brandSites,
        zipCoordinates: state.zipCoordinates,
        stateCoordinates: state.stateCoordinates,
        loading: state.loading,
        formLevel: state.formLevel,
        age: state.age,
        pass: state.pass,
        intialFilledOut: state.intialFilledOut,
        parentsInfoFilledOut: state.parentsInfoFilledOut,
        getEmailFilledOut: state.getEmailFilledOut,
        addressFiledOut: state.addressFiledOut,
        mailingFiledOut: state.mailingFiledOut,
        preSelected: state.preSelected,
        charterBrandName: state.charterBrandName,
        learningCenterName: state.learningCenterName,
        learningCenterCharter: state.learningCenterCharter,
        levelUp,
        levelDown,
        getAge,
        setPass,
        setLearningCenter,
        onFormDataChange,
        applyFilter,
        onZipSearchChange,
        getZipLocations,
        setLoading,
        submitData,
        submitDataPublic,
        preSelectedSite,
        charterPreSelected,
        getSiteInformation,
        getBrandbySite,
        getSiteprogram,
        getProgramtypesforweb,
        getSchoolTypesforweb,
        setCampaignType,
        sendInterestEmail,
        getBrandName,
        resetInterestForm
      }}>
      {props.children}
    </InterestContext.Provider>
  );
};

export default InterestState;
